const { bundle_product, bundle_collection_id } = window.liquidData;
const discountCode = 'SAVE-KMRD';
let isAddingToCart = false;
let inflight = { controller: null, requestId: 0, latestId: 0 };
let preAddTimer = null;
let latestSelectedItems = null; // last selected items we intend to pre-add
let selectedVariantId = null; // synced across all selectors

function validateLiquidData() {
  if (!window.liquidData) {
    console.warn('Error: window.liquidData is not defined.');
    return false;
  }

  if (!bundle_product || typeof bundle_product !== 'object' || !bundle_product.id) {
    console.warn('Error: bundle_product is missing or invalid.');
    return false;
  }

  if (typeof bundle_collection_id !== 'string' && typeof bundle_collection_id !== 'number') {
    console.warn('Error: bundle_collection_id is missing or invalid.');
    return false;
  }

  return true;
}

// set up buttons 
function setupStickyCtaObservers(stickyButton) {
  const section_to_hide = document.getElementById('one-to-three__main-sections');

  if (!section_to_hide || !stickyButton) {
    console.error(
      'Main sections or sticky CTA container or sticky spacer not found, add id="one-to-three__main-sections" to the main sections and id="sticky-cta" to the sticky CTA container'
    );
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        stickyButton.classList.remove('sticky-bottom');
      } else {
        stickyButton.classList.add('sticky-bottom');
      }
    },
    { threshold: 0 }
  );

  observer.observe(section_to_hide);
}

function setupRadioButtons(allButtons) {
  if (!allButtons || allButtons.length === 0) {
    console.error('No add to cart buttons found, add data-action="add-to-cart" to any add to cart button');
    return;
  }

  allButtons.forEach((button) => {
    button.addEventListener('click', (event) => handleRadioButtonClick(event, allButtons));
  });
}

function setupScrollToSelectorButtons(buttons) {
  if (!buttons || buttons.length === 0) {
    console.error(
      'No scroll to selector buttons found, add data-action="scroll-to-selector" to any scroll to selector button'
    );
    return;
  }
  const selectorSection = document.getElementById('one-to-three__offer-scent-selector');
  if (!selectorSection) {
    console.error('Selector section not found, add id "one-to-three__offer-scent-selector" to the selector section');
    return;
  }
  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      selectorSection.scrollIntoView({ behavior: 'smooth' });
    });
  });
}

function setupGoToCheckoutButton(buttons) {
  if (!buttons || buttons.length === 0) {
    console.error(
      'No scroll to selector buttons found, add data-action="scroll-to-selector" to any scroll to selector button'
    );
    return;
  }

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      setCheckoutBtnLoading(button);
      goToCheckout();
    });
  });
}



// recharge 
async function createRechargeBundleItems(items) {
    const bundleProductData = {
        productId: bundle_product.id,
        variantId: bundle_product.variants[0].id,
        sellingPlan: bundle_product.variants[0].selling_plan_allocations[0].selling_plan_id,
        handle: bundle_product.handle,
    }


    // Validate bundle product data
    if (!bundleProductData.productId || !bundleProductData.variantId || !bundleProductData.sellingPlan) {
        throw new Error('Bundle product configuration error: Missing required product, variant, or selling plan data');
    }

    if (!bundleProductData.handle) {
        throw new Error('Bundle product configuration error: Missing product handle');
    }

    const bundle = {
        externalVariantId: bundleProductData.variantId,
        externalProductId: bundleProductData.productId,
        selections: items,
    };

    const itemsWithBundles = await recharge.bundle.getDynamicBundleItems(bundle, bundleProductData.handle);
    return itemsWithBundles;
}

async function prepareBundleCartItems(cartItems) {
    const bundleItems = cartItems.filter(item => item.selling_plan);

    const finalBundleItems = bundleItems.map(item => ({
        collectionId: bundle_collection_id,
        externalProductId: bundle_product.id,
        externalVariantId: item.id,
        quantity: item.quantity,
        sellingPlan: item.selling_plan
    }));

    const bundleCartItems = await createRechargeBundleItems(finalBundleItems);
    return [...bundleCartItems];
}

// event handlers 

function handleRadioButtonClick(event, allButtons) {
  const btn = event.currentTarget;
  const variantId = btn.dataset.variantId;
  const productId = btn.dataset.productId;
  const sellingPlanId = btn.dataset.sellingPlan;

  if (!variantId || !productId || !sellingPlanId) {
    console.error('Variant ID / product ID / selling plan missing.');
    return;
  }

  // sync selected variant state
  selectedVariantId = Number(variantId);

  // sync UI
  allButtons.forEach(b => {
    const isMatch = b.dataset.variantId === variantId;
    if (isMatch) {
      b.setAttribute('data-selected', 'true');
    } else {
      b.removeAttribute('data-selected');
    }
  });

  // update cart
  latestSelectedItems = [{
    id: Number(variantId),
    quantity: 1,
    selling_plan: sellingPlanId,
  }];

  if (preAddTimer) clearTimeout(preAddTimer);
  if (inflight.controller) inflight.controller.abort();

  preAddTimer = setTimeout(preAddSelectedItems, 250);
}

function syncVisualSelection(allButtons) {
  allButtons.forEach((b) => {
    if (Number(b.dataset.variantId) === selectedVariantId) {
      b.setAttribute('data-selected', 'true');
    } else {
      b.removeAttribute('data-selected');
    }
  });
}


// add to cart requests
async function preAddSelectedItems() {
  if (!latestSelectedItems) return;

  // New request id and controller
  inflight.requestId += 1;
  inflight.latestId = inflight.requestId;
  const myId = inflight.requestId;
  inflight.controller = new AbortController();
  const { signal } = inflight.controller;

  setIsAddingFlag(true);

  try {
    // Build bundle items (cannot be aborted, so guard after it completes)
    const bundleProcessedItems = await prepareBundleCartItems(latestSelectedItems);
    if (myId !== inflight.latestId || signal.aborted) return; // stale

    // Replace cart with the latest selection
    await addToCart(bundleProcessedItems, { signal, requestId: myId });
  } catch (err) {
    if (err.name === 'AbortError') {
      // ignore; a newer selection superseded this one
      return;
    }
    console.error('preAddSelectedItems error:', err);
    // Only drop the loading flag if this was still the latest request
    if (myId === inflight.latestId) setIsAddingFlag(false);
  }
}

async function clearCart(signal) {
  return fetch('/cart/clear.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    signal
  });
}


async function addToCart(items, { signal, requestId } = {}) {
  try {
    await clearCart(signal);
    const resp = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
      signal
    });
    if (!resp.ok) {
      console.error('Network not ok, payload:', items);
      throw new Error('Network response was not ok');
    }
    return await resp.json();
  } catch (error) {
    // If aborted, surface a clean AbortError so caller can ignore
    if (signal && signal.aborted) {
      const abortErr = new DOMException('Aborted', 'AbortError');
      abortErr.name = 'AbortError';
      throw abortErr;
    }
    throw error;
  } finally {
    // Only the latest request toggles the global flag off
    if (requestId === inflight.latestId) setIsAddingFlag(false);
  }
}

function setIsAddingFlag(payload) {
  isAddingToCart = payload;
}

// go to checkout page 
function setCheckoutBtnLoading(button) {
  button.setAttribute('data-loading', true)
  button.disabled = true;
}

function goToCheckout() {
  const redirectRoute = `/discount/${discountCode}?redirect=/checkout`;
  if (!isAddingToCart) {
    window.location = redirectRoute;
    return;
  }

  let waited = 0;
  const interval = 100;
  const maxWaitMs = 10000;

  const checkInterval = setInterval(async () => {
    waited += interval;
    if (!isAddingToCart) {
      clearInterval(checkInterval);
      window.location = redirectRoute;
      return;
    }
    if (waited >= maxWaitMs) {
      clearInterval(checkInterval);
      // Final reconcile to ensure cart matches the last selection before redirect
      if (inflight.controller) inflight.controller.abort(); // stop any stale work
      await preAddSelectedItems(); // kicks a final “latest” add
      window.location = redirectRoute;
    }
  }, interval);
}

// sticky cta expand / collapse 
let isStickySelectorDrawerExpanded = false;
function setupStickyCtaSelectorDrawer() {
  const stickyCtaButton = document.getElementById('expand-sticky-selector-btn')
  const stickySelectorDrawer = document.getElementById('sticky-selector')
  const pageContainer = document.getElementById('page-container')

  if (!stickyCtaButton || !stickySelectorDrawer || !pageContainer) {
    console.log('missing stickyCtaButton or stickySelectorDrawer or pageContainer, add divs with #expand-sticky-selector-btn or #sticky-selector or #page-container')
    return;
  }

  const expandedBtnText = stickyCtaButton.querySelector('[data-sticky-cta-text="expanded"]')
  const collapsedBtnText = stickyCtaButton.querySelector('[data-sticky-cta-text="collapsed"]')

  if (!expandedBtnText || !collapsedBtnText) {
      console.log('missing btnText divs, add divs with [data-sticky-cta-text="expanded"] and [data-sticky-cta-text="collapsed"]')
    return;
  }

  function toggleStickySelectorDrawer() {
    isStickySelectorDrawerExpanded = !isStickySelectorDrawerExpanded;
    stickySelectorDrawer.classList.toggle('active')
    expandedBtnText.classList.toggle('hidden')
    collapsedBtnText.classList.toggle('hidden')
    pageContainer.classList.toggle('dimmed')
  }
  stickyCtaButton.addEventListener('click', () => {
    if (!isStickySelectorDrawerExpanded) {
      toggleStickySelectorDrawer()
      document.body.style.overflow = 'hidden';
    } else {
      setCheckoutBtnLoading(stickyCtaButton);
      goToCheckout();
    }
  })

  pageContainer.addEventListener('click', () => {
    if (isStickySelectorDrawerExpanded) {
      toggleStickySelectorDrawer()
      document.body.style.overflow = '';
    }
  })
}


// DOMContentLoaded listener 
document.addEventListener('DOMContentLoaded', function () {
  const isLiquidDataValid = validateLiquidData();
  if (!isLiquidDataValid) {
    console.error('Validation of liquid data failed. Check console for details.');
    return;
  }

  const container = document.querySelector('.one-to-three_page');
  if (!container) {
    console.error('Container not found, add class="one-to-three_page" to the page container');
    return;
  }

  const stickyCtaButton = document.getElementById('sticky-cta');
  setupStickyCtaObservers(stickyCtaButton);

  const addToCartButtons = container.querySelectorAll('[data-action="add-to-cart"]');
  setupRadioButtons(addToCartButtons);

  const scrollToSelectorButtons = container.querySelectorAll('[data-action="scroll-to-selector"]');
  setupScrollToSelectorButtons(scrollToSelectorButtons);


  const checkoutBtns = container.querySelectorAll('[data-action="go-to-checkout"]');
  setupGoToCheckoutButton(checkoutBtns);

  setupStickyCtaSelectorDrawer();

  // click first button to create default selection 
  if (addToCartButtons && addToCartButtons.length > 0) {
    addToCartButtons[0].click();
    // re-sync both selectors visually
    syncVisualSelection(addToCartButtons);
  } else {
    console.log('no radio items with [data-action="add-to-cart"] found, cannot set default selection')
  }
});